import { Controller } from "@hotwired/stimulus"
import { Modal } from "bootstrap"

export default class extends Controller {
  connect() {
    const modal_element = this.element
    modal_element.querySelector('.modal-dialog').classList.add("modal-lg")
    this.modal = new Modal(this.element)
    this.modal.show()
  }
}
